module.exports = __webpack_public_path__ + "static/media/icon-artTips.93594f02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-artTips.svg
// module id = 949
// module chunks = 0